import React from 'react';
import './style/RefundPolicy.css';
import TopNavbar from './TopNavbar';

const RefundPolicy = () => {
  const lastUpdated = "August 2026";
  const paymentsEmail = "payments@mystudyplace.in";
  const backupEmail = "sarwar93390@gmail.com";

  return (
    <div className="refund-policy-page">
      <TopNavbar name="Refund Policy" />

      <div className="refund-header">
        <h1>Refund Policy</h1>
        <p className="last-updated">Last Updated: {lastUpdated}</p>
      </div>

      <div className="refund-content">
        {/* Important Notice */}
        <div className="no-refund-banner">
          <div className="warning-icon">⚠️</div>
          <h2>No Refunds Policy for Subscriptions</h2>
          <p>
            <strong>ALL DIGITAL PURCHASES &amp; SUBSCRIPTIONS ARE FINAL AND NON-REFUNDABLE ONCE CONTENT ACCESS IS UNLOCKED.</strong>
          </p>
        </div>

        {/* Section 1: Billing Gateway */}
        <div className="policy-section">
          <h3>1. Billing &amp; Payment Processing</h3>
          <p>
            All in-app purchases, subscriptions, and test series packages within <strong>NEET Prep</strong> are processed securely through <strong>Google Play Billing</strong>. We do not store or collect your payment credentials (credit/debit cards, UPI, net banking) on our servers.
          </p>
        </div>

        {/* Section 2: Failed Payments & Technical Issues */}
        <div className="policy-section">
          <h3>2. Payment Failure &amp; Access Support Scenarios</h3>
          <p>
            While active subscriptions are non-refundable, Google Play handles transaction anomalies as follows:
          </p>
          <div className="no-refund-list">
            <div className="refund-item">
              <span className="item-icon">🔄</span>
              <div>
                <strong>Failed Payment / Money Debited Automatically Refunded</strong>
                <p>
                  If money is deducted from your bank account or wallet but the order fails within the app, Google Play will automatically process a full refund to your original payment method within 3 to 7 working days.
                </p>
              </div>
            </div>

            <div className="refund-item">
              <span className="item-icon">📩</span>
              <div>
                <strong>Payment Debited but Content Not Unlocked</strong>
                <p>
                  If your payment was successful but your test series or subscription remains locked, please contact us immediately with your <strong>Google Play Order ID</strong> (e.g., <code>GPA.1234-5678-9012-34567</code>). Our team will manually verify and activate your content access.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3: Digital Product Nature */}
        <div className="policy-section">
          <h3>3. Digital Content Nature &amp; No-Refund Scenarios</h3>
          <p>
            NEET Prep provides immediate, digital access to test prep content (mock tests, practice papers, analytics, and study notes). Due to the immediate delivery of digital goods, refunds are <strong>NOT</strong> provided in the following cases:
          </p>
          <div className="no-refund-list">
            <div className="refund-item">
              <span className="item-icon">❌</span>
              <div>
                <strong>Change of Mind</strong>
                <p>Deciding you no longer wish to study using the platform after purchase.</p>
              </div>
            </div>
            <div className="refund-item">
              <span className="item-icon">❌</span>
              <div>
                <strong>Non-Usage</strong>
                <p>Choosing not to take mock tests or view content during your active period.</p>
              </div>
            </div>
            <div className="refund-item">
              <span className="item-icon">❌</span>
              <div>
                <strong>Dissatisfaction</strong>
                <p>Unmet personal performance expectations or personal exam date changes.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 4: Subscription Cancellation */}
        <div className="policy-section">
          <h3>4. Subscription Management &amp; Auto-Renewal</h3>
          <ul>
            <li>All active subscription period purchases are final and non-refundable.</li>
            <li>There are no partial or prorated refunds for unused days in a billing cycle.</li>
            <li>
              You can cancel subscription auto-renewals at any time by navigating to <strong>Google Play Store &gt; Payments &amp; subscriptions</strong>.
            </li>
            <li>Canceling stops future recurring charges, but your content access will remain active until the current paid period ends.</li>
          </ul>
        </div>

        {/* Final Acknowledgement */}
        <div className="acknowledgement-section">
          <h3>Important Acknowledgement</h3>
          <div className="acknowledgement-box">
            <p>
              <strong>
                By completing a purchase inside NEET Prep, you confirm that you have read, understood, and accepted this Refund Policy and agree that all completed purchases are non-refundable.
              </strong>
            </p>
          </div>
        </div>

        {/* Support Section */}
        <div className="support-section">
          <h3>Payment Support &amp; Assistance</h3>
          <p>
            If you experience payment issues or need help unlocking your purchased content, please reach out with your Google Play Order ID:
          </p>
          <div className="support-contact">
            Email: <a href={`mailto:${paymentsEmail}?subject=NEET%20Prep%20Payment%20Issue`} className="email-button">
              {paymentsEmail}
            </a> <br />
            Gmail: <a href={`mailto:${backupEmail}?subject=NEET%20Prep%20Payment%20Issue`} className="email-button">
              {backupEmail}
            </a>
          </div>
        </div>
        <br></br><br></br><br></br>
      </div>
    </div>
  );
};

export default RefundPolicy;